exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-tab-list{border-bottom:var(--ds-border-rule);border-top:var(--ds-border-rule--emphasised);display:flex}@media (max-width:37.4375rem){.ds-tab-list--adjacent{flex-direction:column}}", ""]);

// exports
exports.locals = {
	"ds-tab-list": "ds-tab-list",
	"ds-tab-list--adjacent": "ds-tab-list--adjacent"
};